/* import __COLOCATED_TEMPLATE__ from './prose-block.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();